import React, { useState, useEffect, useCallback } from "react";
import WorkorderService from "../services/workorders";
import WorkorderList from "../components/workorders/workorderlist";
import ActionButton from '../components/layout/actionButtons';
import Search from "../components/general/search";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SelectReact from 'react-select';

const compare = (a, b) => {
  if (a.created < b.created) return 1;
  if (a.created > b.created) return -1;
  return 0;
};

const filterYear = (items, year) => {
  if (year === 0) return items;
  return items.filter(item => new Date(item.created).getFullYear() === year);
};

const getYears = () => {
  //let retValue = [{ value: 0, label: 'Bekijk alle jaren' }];
  let retValue = [];
  for (let y = 2019; y <= new Date().getFullYear(); y++) {
    retValue.push({ value: y, label: y });
  }
  return retValue;
};

const WorkordersAdmin = (props) => {
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(() => {
    const stored = localStorage.getItem('selectedTabAdmin');
    return stored ? parseInt(stored) : 0;
  });
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    props.handleMenu({
      title: 'Beheer werkbonnen',
      handleActions: <ActionButton {...props} />
    });
  //  getItems();
    // eslint-disable-next-line
  }, []);

  //const getItems = useCallback(() => {
    useEffect(() => {
   
    WorkorderService.getAdmin(year).then(
      result => {
        result = result.sort(compare);
        setItems(result);
        setFilterItems(result);
   //     setFilterItems(filterYear(result, year));
      },
      error => {
        console.log("error", error);
      }
    );
  }, [year]);

 // useEffect(() => {
  //  setFilterItems(filterYear(items, year));
  // getItems();
  //}, [items, year]);

  const editItem = (item) => {
    if (props.isAdmin) {
      props.history.push('/workordersadmin/' + item.guid);
    } else {
      props.history.push('/workorders/' + item.guid);
    }
  };

  const handleChangeStatusTab = (event, value) => {
    localStorage.setItem('selectedTabAdmin', value);
    setSelectedStatus(value);
  };

  const handleSearch = (search) => {
    let filtered = items;//filterYear(items, year);
    filtered = filtered.filter(item =>
      JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
    setFilterItems(filtered);
  };

  const changeYear = (newYear) => {
    setYear(newYear);
  //  setFilterItems(filterYear(items, newYear));
  };

  const filteredByStatus = filterItems.filter(item => item.status === selectedStatus);
  const countConcept = filterItems.filter(item => item.status === 0).length;
  const countIncomming = filterItems.filter(item => item.status === 1).length;
  const countOpen = filterItems.filter(item => item.status === 2).length;
  const countArchive = filterItems.filter(item => item.status === 3).length;

  return (
    <React.Fragment>
      <AppBar position="static" color="secondary">
        <Tabs value={selectedStatus} onChange={handleChangeStatusTab}>
          <Tab label={`Concept (${countConcept})`} />
          <Tab label={`Ingekomen (${countIncomming})`} />
          <Tab label={`Openstaand (${countOpen})`} />
          <Tab label={`Archief (${countArchive})`} />
        </Tabs>
      </AppBar>
      <Search handleSearch={handleSearch} />
      <SelectReact
        options={getYears()}
        onChange={ev => changeYear(ev.value)}
        defaultValue={{ value: year, label: year }}
      />
      <div>
        <WorkorderList
          items={filteredByStatus}
          handleEdit={editItem}
          showUserInfo={true}
          status={selectedStatus}
        />
      </div>
    </React.Fragment>
  );
};

export default WorkordersAdmin;
